export default __webpack_public_path__ + "static/media/bisrat-huawei-1.0deeb8aa.png";